import { CartProductItem } from '@westwing/ui-kit/ContentFlyout/CartFlyout/types';

export type EventType = keyof EventData;

export type EventData = {
    ADDED_TO_CART: {
        // eslint-disable-next-line camelcase
        seconds_left: number;
        total: number;
        expired: boolean;
        products: CartProductItem[];
        totalPrice: string;
        // eslint-disable-next-line camelcase
        delivery_times_changed: boolean;
    };
    CART_EXPIRED: undefined;
    CART_TIMER_TICK: number;
    CART_EXPIRING: undefined;
    CART_REMIND: undefined;
    CART_NOTIFY: undefined;
    CART_RESTORED: number;
    BURGER_MENU_OPEN: undefined;
    SHARE_MODAL_OPEN: undefined;
    USER_LOADED: {
        id: string | null;
        email: string | null;
        totalVoucherAmount: number | null;
        isConfirmed: boolean;
        isLoggedIn: boolean;
        isMember: boolean;
    };
    SIGNUP_OVERLAY_OPEN: {
        contentHubReferralVoucher?: boolean;
        isClosable?: boolean;
        onClose?: () => void;
        hiddenCloseButton?: boolean;
        forcePasswordless?: boolean;
        customDoiOverlay?: boolean;
        signupOverlayWithImage?: {
            imageUrl?: string;
            mobileImageUrl?: string;
            variant: string;
            isVariantB: boolean;
        };
        newRedirectUrl?: string;
    };
    SHOW_SHOP_ONBOARDING_TOOLTIP: undefined;
};

export type Listener<T extends EventType> = (data: EventData[T]) => void;
type EventMap = {
    [K in EventType]: { event: K; listener: Listener<K> };
};
export type EventEntry = EventMap[keyof EventMap];

type WWEvents = EventEntry[] & {
    fire<T extends EventType>(event: T, data: EventData[T]): void;
    remove<T extends EventType>(eventType: T, callback: Listener<T>): void;
};

window.WWEvents = window.WWEvents || [];
window.WWEvents.fire = window.WWEvents.fire || (() => undefined);
window.WWEvents.remove = window.WWEvents.remove || (() => undefined);

export default window.WWEvents;

declare global {
    interface Window {
        WWEvents: WWEvents;
    }
}
